export default __webpack_public_path__ + "static/media/grafema_ummi_02.f2efd7fe.jpg";